

export enum TruckStatus {
  AVAILABLE = "available",
  UNAVAILABLE = "unavailable",
  IN_TRANSIT = "in_transit",
  LOADING = "loading",
  UNLOADING = "unloading",
  MAINTENANCE = "maintenance",
}

export type CapacityUnit = "kg" | "ton" | "lb";

export type EngineType =
  | "diesel"
  | "petrol"
  | "hybrid"
  | "electric"
  | "cng"
  | "other";

export interface TruckMetadata {
  ar_plate_number?: string | null;
  en_plate_number?: string | null;
  empty_weight?: number | null; // KG
  car_model?: string | null;
  capacity_unit?: CapacityUnit | null;
  fuel_consumption_km_per_l?: number | null;
  engine_type?: EngineType | null;
  vin?: string | null;
  vehicle_type?: string | null;
  /** Amount in SAR per trip */
  price_per_trip?: number | null;
  truck_features?: string[] | null;
}

export interface TruckSchema {
  id: string;
  name: string;
  capacity: number;
  status: TruckStatus;
  organization_id: string;
  driver_id?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  data: TruckMetadata | null;
  created_at: string;
  updated_at: string;
}

export interface TruckRequest {
  name: string;
  capacity: number;
  status: TruckStatus;
  organization_id: string;
  driver_id?: string | null;
  data?: TruckMetadata | null;
}

export interface UpdateTruckRequest {
  name?: string;
  status: TruckStatus;
  capacity?: number;
  driver_id?: string | null;
  data?: TruckMetadata | null;
}

export interface TruckQueryParams {
  organization_id: string;
  page?: number;
  limit?: number;
  search?: string;
}

export interface PaginatedTruckResponse {
  trucks: TruckSchema[];
  total: number;
}

// Driver types – POST /truck/driver/register uses top-level fields (same as admin)
export interface DriverRegisterRequest {
  username?: string;
  password: string;
  password_confirm: string;
  organization_id: string;
  truck_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  phone?: string | null;
  gender?: string | null;
  nationality?: string | null;
  date_of_birth?: string | null;
  iban?: string | null;
  driver_license_expiry?: string | null;
  driver_license_number?: string | null;
  vehicle_registration_number?: string | null;
  total_points?: number;
}

export interface AssignDriverRequest {
  driver_id: string;
}

export interface DriverSchema {
  id: string;
  username: string;
  status: 'active' | 'inactive';
  data: {
    permissions: Record<string, string[]>;
    driver_license_number?: string;
    vehicle_registration_number?: string;
    [key: string]: any;
  };
  created_at: string;
  updated_at: string;
}

// Driver Details API (GET /truck/driver/:driver_id)
export interface TruckDriverInfo {
  id: string;
  username: string;
  phone: string | null;
}

export interface DriverHistoricalOrder {
  delivery_id: string;
  delivery_name: string;
  pickup_order_id: string;
  completed_at: string | null;
  waste_type: string;
  amount: number;
  recycler_name: string | null;
}

export interface DriverDetails {
  driver: TruckDriverInfo;
  truck: TruckSchema | null;
  historical_orders: DriverHistoricalOrder[];
}
